import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

export const Root = styled.div`
  border: 1px solid rgba(18, 36, 66, 0.5);
  overflow: hidden;
  background-color: ${C.WHITE};
`

export const ProgressBar = styled.div`
  height: 100%;
  background-color: #75d29a;
  transition: width 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`